// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_su-0";